import { useContext } from 'react';
import { AppContext, IAppContext } from '@mayfield/website/context';

export const useApp = (): IAppContext => useContext(AppContext);
